import { ContractSigner } from 'types';

export const columns: (keyof ContractSigner)[] = [
	'name',
	'role',
	'email',
	'kennitala',
	'phoneNumber',
	'hasScannedIdentity',
	'hasSigned',
	'hasSigningAuthority'
];
